import { Link } from 'react-router-dom';
import { useOrgWorkspaceNav } from '../../../providers/useOrgWorkspaceNav';

/**
 * Hub back link: My projects, or org landing when chrome branding is active.
 *
 * @param {'short' | 'long' | 'root'} [variant]
 *   short — "← Projects" / "← {brand}"
 *   long  — "← Back to Projects" / "← Back to {brand}"
 *   root  — "Projects" / "{brand}" (no arrow; for breadcrumbs)
 */
export default function ProjectsHubBackLink({
    className,
    variant = 'short',
    ...rest
}) {
    const { hubHomeTo, hubBackLabel, hubBackLabelLong, hubRootLabel } = useOrgWorkspaceNav();

    let label = hubBackLabel;
    if (variant === 'long') label = hubBackLabelLong;
    if (variant === 'root') label = hubRootLabel;

    return (
        <Link to={hubHomeTo} className={className} {...rest}>
            {label}
        </Link>
    );
}
